
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import { usersVerifyPass, donationRevalidate } from '../../../libs/services';
var Config = require('../../../config');

class ModalReval extends Component{
	constructor(props) {
		super(props);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onReval = this.onReval.bind(this);
		this.handleChange = this.handleChange.bind(this);
        this.validUser = this.validUser.bind(this);
		this.state = {
		    show: false,
		    reval_user:sessionStorage.getItem('user_name'),
		    reval_pass:"",
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleClose() {
		this.setState({ show: false, reval_pass:""});
	}

	handleShow() {
		this.setState({ show: true});
	}

	handleChange(e){
	    this.setState({
	      [e.target.name]: e.target.value
	    });
	}

	isValidForm() {
	    const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

    async validUser(){
        if(this.isValidForm()){
			var password = btoa(this.state.reval_pass);
			password = password.split("").reverse().join("");

			var obj = {
				username:this.state.reval_user,
				password:password
			};
		
			var response = await usersVerifyPass(obj, this.props.waiting);
			if(response !== undefined){
				this.onReval();
			}
			
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}	
    }

	async onReval(){
		let response = await donationRevalidate(this.props.donation_id);
		if(response){
            this.handleClose();
            this.props.getData();
        }
			
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Revalidar Donación</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{textAlign:"center"}}>
		        		<div className="col-xs-12 col-sm-10 col-md-offset-1">
		        			<div className="col-xs-12 form-group">
                                <div className='col-xs-12'>
                                    <h3>¿ESTÁ SEGURO DE ACEPTAR LA DONACIÓN CON RESULTADOS REACTIVOS?</h3>
                                </div>

			        			<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			Usuario
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="reval_user" id="reval_user"						        		
						        		value={this.state.reval_user}
						        		onChange={this.handleChange}
                                        autoComplete="off"
                                        disabled
						        		required/>
					        	</div>
				        	</div>

				        	<div className="form-group col-xs-12">
					        	<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			Contraseña
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="reval_pass" id="reval_pass"
						        		type="password"
						        		value={this.state.reval_pass}
						        		onChange={this.handleChange}
                                        autoComplete="off"
						        		required/>
					        	</div>
				        	</div>
			        	</div>
			        	
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={"Si, Revalidar"} onClick={this.validUser}/>
		        	<FlatButton primary={true} label={'No, '+t('content.generics.buttons.reset')} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalReval) 